import { getPaymentMethodIcon } from '@sg/garnish';
import { type BraintreeCardType, CardType } from '@sg/graphql-schema';

// Representing an apple pay payment method.
export const APPLE_PAY = 'ApplePay';

// Representing an apple pay payment method.
export const PAYMENT_ADD = 'ADD';

/**
 * The card type can be from any provider, so we map it here.
 */
export function getCreditCardIcon(
  cardType:
    | CardType
    | BraintreeCardType
    | typeof PAYMENT_ADD
    | typeof APPLE_PAY = CardType.Unsupported,
  shouldUseAddIcon?: boolean,
) {
  switch (cardType) {
    case PAYMENT_ADD: {
      return shouldUseAddIcon ? 'IconPlus' : 'IconCreditCard';
    }

    default: {
      return getPaymentMethodIcon(cardType);
    }
  }
}
